import React, { useEffect, useState } from "react"
import { cities } from "../../config"
import { navigate } from "gatsby"
import "./styles.less"

export default ({
  title,
  className = "",
  onDemand = false,
  locationsPage = false,
}) => {
  const [teamSize, setTeamSize] = useState("1")
  const [step, setStep] = useState(1)
  const [type, setType] = useState("Private office")
  const [teamSizeSelector, setTeamSizeSelector] = useState(false)
  const [searchCity, setSearchCity] = useState(cities[0])

  useEffect(() => {
    setStep(1)
  }, [onDemand])

  const search = () => {
    if (Number(teamSize) <= 2 && !onDemand) {
      setStep(2)
    } else {
      goToResults()
    }
  }
  const setTypeAndSearch = (val) => {
    setType(val)
    goToResults(val)
  }

  const prevStep = (e) => {
    e.preventDefault()
    setStep(1)
  }

  const teamSizeClickHandle = (e) => {
    setTeamSizeSelector(false)
  }

  useEffect(() => {
    setTeamSizeSelector(false)
    window.addEventListener("click", teamSizeClickHandle)

    return () => {
      window.removeEventListener("click", teamSizeClickHandle)
    }
  }, [teamSize])

  const goToResults = (spaceType = null) => {
    if (!onDemand) {
      navigate(
        `/locations?current_staff=${teamSize}&location=${searchCity}&space_type=${
          spaceType || type
        }`
      )
    } else {
      navigate(
        `/${process.env.GATSBY_ON_DEMAND_SLUG}?current_staff=${teamSize}&location=${searchCity}`
      )
    }
  }

  return (
    <div className={`onboarding-wrapper ${className}`}>
      <div className={step === 1 ? "visible" : "hidden"}>
        {title && <h1 className={"h2"}>{title}</h1>}
        <label htmlFor="city">Select City</label>
        <select
          name="city"
          id="city"
          className={"form-control"}
          value={searchCity}
          onChange={(e) => setSearchCity(e.target.value)}
        >
          {cities.map((city) => (
            <option value={city} key={city}>
              {city}
            </option>
          ))}
        </select>
        <div className="team-size-wrapper" onClick={(e) => e.stopPropagation()}>
          <label htmlFor="size">Number of People</label>
          <input
            type="text"
            value={teamSize}
            id="team_size"
            className={"form-control"}
            readOnly
            onClick={() => setTeamSizeSelector(!teamSizeSelector)}
          />
          <div
            className={`form-group team-size-selector ${
              teamSizeSelector ? "show" : ""
            }`}
          >
            <h5>How many people need office space?</h5>
            <ul>
              {slots.map((number) => (
                <li
                  key={number}
                  onClick={() => setTeamSize(number.toString())}
                  className={teamSize === number.toString() ? "active" : ""}
                >
                  {number}
                </li>
              ))}
              <li
                className={`long ${teamSize === "21-50" ? "active" : ""}`}
                onClick={() => setTeamSize("21-50")}
              >
                21-50
              </li>
              <li
                className={`long ${teamSize === "51-100" ? "active" : ""}`}
                onClick={() => setTeamSize("51-100")}
              >
                51-100
              </li>
            </ul>
          </div>
        </div>
        <button onClick={search} className={"btn btn-primary"}>
          Find workspace
        </button>
      </div>

      <div
        className={`${step === 2 ? "visible" : "hidden"} type-selector ${
          locationsPage ? "on-demand" : ""
        }`}
      >
        <p className="h4">What kind of workspace are you looking for? </p>
        <button
          className="btn btn-primary"
          onClick={() => setTypeAndSearch("Private Offices")}
        >
          Private Offices
        </button>
        <button
          className="btn btn-primary"
          onClick={() => setTypeAndSearch("Dedicated desks")}
        >
          Dedicated desks
        </button>
        <a href="#" className={"btn btn-link chev-left"} onClick={prevStep}>
          Back
        </a>
      </div>
    </div>
  )
}

const slots = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
]
